import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from "@angular/router";
import { ProvidehttpService } from '../providehttp.service';

@Component({
  selector: 'app-session-timeout-page',
  templateUrl: './session-timeout-page.component.html',
  styleUrls: ['./session-timeout-page.component.scss']
})
export class SessionTimeoutPageComponent implements OnInit {

  constructor(private router: Router,public http:ProvidehttpService, private ngZone: NgZone) { }

  ngOnInit() {
  }
  gotoWelcomePage(){
    //this.router.navigate(['/home/dashboard']);
    // const sessionTimeoutEvt = new CustomEvent('onForceLogout', { detail: window['mainScope'] });
    // window.dispatchEvent(sessionTimeoutEvt);
    this.ngZone.run(() => {
      this.router.navigate(["welcome", "appnavigator"]);
      });
  }
}
